import axios from 'axios';
import { ABR_GUID } from '../../../config';

let businessNameSource, abnSource;
/** Action creators */
export const lookupBusinessName = async (businessName) => {
  const url = `https://abr.business.gov.au/json/MatchingNames.aspx?name=${businessName}&maxResults=10&callback=bcb&guid=${ABR_GUID}`;
  if (businessNameSource) {
    businessNameSource.cancel('Operation canceled by the user.');
  }
  businessNameSource = axios.CancelToken.source();
  let options = {
    cancelToken: businessNameSource.token
  };
  const resp = await axios.get(url, options);
  let abnData = resp.data.replace(/bcb\((.*)\)/m, '$1');
  try {
    abnData = JSON.parse(abnData);
    return abnData.Names.map((record) => ({
      abn: record.Abn,
      abnStatus: record.AbnStatus,
      isCurrent: record.IsCurrent,
      state: record.State,
      postcode: record.Postcode,
      name: record.Name,
      nameType: record.NameType,
      score: record.Score
    }));
  } catch {
    return null;
  }
};

export const lookupABN = async (abn) => {
  const url = `https://abr.business.gov.au/json/AbnDetails.aspx?guid=${ABR_GUID}&abn=${abn}&callback=bcb`;
  if (abnSource) {
    abnSource.cancel('Operation canceled by the user.');
  }
  abnSource = axios.CancelToken.source();
  let options = {
    cancelToken: abnSource.token
  };
  const resp = await axios.get(url, options);
  let abnData = resp.data.replace(/bcb\((.*)\)/m, '$1');
  try {
    abnData = JSON.parse(abnData);
    return {
      abn: abnData.Abn,
      abnStatus: abnData.AbnStatus,
      acn: abnData.Acn,
      addressDate: abnData.AddressDate,
      addressPostcode: abnData.AddressPostcode,
      addressState: abnData.AddressState,
      businessName: abnData.BusinessName,
      entityName: abnData.EntityName,
      entityTypeCode: abnData.EntityTypeCode,
      entityTypeName: abnData.EntityTypeName,
      gst: abnData.Gst,
      message: abnData.Message
    };
  } catch {
    return null;
  }
};
